import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Award, TrendingUp, Building, Star, Shield, Target, CheckCircle, Linkedin, Sparkles, UserPlus, Briefcase, X } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import SEO, { SEOPages } from '../components/SEO';

const APropos = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      name: "Joël Ott",
      title: "Co-Fondateur",
      image: "/assets/team/joel-ott.jpg",
      expertise: ["Swiss Life Select (2009-2025) – Top Management", "Entrepreneur multi-secteurs (CareWash, D.A.D Services, Elevatis SA)", "Direction, formation & coaching de plus de 50 conseillers"],
      experience: "16+ ans",
      highlight: "Entrepreneur visionnaire avec plus de 16 ans d'expérience dans le conseil financier, Joël a dirigé des équipes de grande ampleur, piloté des projets à forte croissance et fondé plusieurs entreprises en Suisse romande. Il se distingue par une approche moderne, humaine et orientée résultats, qu'il met aujourd'hui au service du développement d'ATOM Group SA.",
      linkedinUrl: "https://www.linkedin.com/in/joelottfinance/"
    },
    {
      name: "Quentin Mauron",
      title: "Co-Fondateur",
      image: "/assets/team/quentin-mauron.png",
      expertise: ["Brevet fédéral de conseiller financier", "Intervenant HEG Arc", "Fondateur de Puramis SA – Gestion immobilière"],
      experience: "7+ ans",
      highlight: "Ancien manager régional et spécialiste en planification financière globale, Quentin allie leadership humain, expertise technique et culture du coaching. Fort d'une expérience auprès de clients privés et PME ainsi que d'une activité entrepreneuriale dans l'immobilier, il met aujourd'hui sa vision complète et structurée au service de la croissance d'ATOM Group SA.",
      linkedinUrl: "https://www.linkedin.com/in/quentinmauron/"
    },
    {
      name: "Sébastien Krafft",
      title: "CTO",
      image: "/assets/team/sebastien-krafft.jpeg",
      expertise: ["Ingénierie et architecture logicielle", "Innovation technologique", "Transformation digitale"],
      experience: "20+ ans",
      highlight: "Avec plus de 20 ans d'expérience en ingénierie et architecture logicielle dans différents secteurs, il met la technologie et l'innovation au service de la croissance d'ATOM Group SA.",
      linkedinUrl: "https://www.linkedin.com/in/sebastienkrafft/"
    },
    {
      name: "Yaiza Cacabelos Vidal",
      title: "Chief People Officer",
      image: "/assets/team/Yaiza.png",
      expertise: ["Ressources humaines", "Management", "Gestion administrative"],
      experience: "5+ ans",
      highlight: "Forte de 5 ans d'expérience dans la vente, dont 3 ans en tant que manager, Yaiza a développé un sens aigu du terrain et du leadership opérationnel. Titulaire d'un diplôme en Management et RH ainsi que du Certificat de Gestionnaire RH, elle conjugue aujourd'hui expertise humaine et compétences stratégiques au service des équipes et de la croissance d'ATOM Group SA.",
      linkedinUrl: "https://www.linkedin.com/in/yaizacacabelos/"
    },
    {
      name: "Marco Baur",
      title: "Consultant juridique & opérationnel",
      image: "/assets/team/marco-baur.jpg",
      expertise: ["Président de l'IAF de 2009 à 2026", "Legal Counsel des commissions d'assurance qualité (CAQ) de l'IAF", "Expert financier collaboratif", "Médiateur certifié – Chambre Suisse de Médiation Commerciale"],
      experience: "30+ ans",
      highlight: "Président de l'IAF de 2009 à 2026, où il poursuit son engagement comme Legal Counsel des commissions d'assurance qualité, Marco cumule plus de 30 ans d'expérience : CEO de AWD Suisse, Liechtenstein Life et SVAG, membre du comité exécutif de Generali Suisse, administrateur de AWD Holding Allemagne, et membre de la direction de Zurich Assurances, pilotant distribution, réseaux et transformation stratégique.",
      linkedinUrl: "https://www.linkedin.com/in/baur-m/",
      isSenior: true
    },
    {
      name: "André Mueller",
      title: "Consultant Senior",
      image: "/assets/team/andre-mueller.jpeg",
      expertise: ["Conseil patrimonial et fiscal", "Planification financière", "Solutions d'investissement sur mesure"],
      experience: "20+ ans",
      highlight: "Avec plus de 20 ans d'expérience en planification financière, gestion de fortune et accompagnement d'entrepreneurs, André est spécialisé dans la transmission d'entreprise, la planification de retraite et le conseil fiscal. Il apporte à ATOM Group SA une expertise rigoureuse, personnalisée et orientée résultats pour les situations patrimoniales complexes.",
      linkedinUrl: "https://www.linkedin.com/in/andré-mueller-2735867/"
    },
    {
      name: "Edouard Barreau",
      title: "Planificateur financier Senior",
      image: "/assets/team/edouard-barreau.jpeg",
      expertise: ["Accompagnement des expatriés francophones en Suisse", "Financement immobilier", "Optimisation fiscale", "Planification retraite"],
      experience: "12+ ans",
      highlight: "Fort de plus de 12 ans d'expérience dans le conseil financier en Suisse, Édouard accompagne une clientèle privée et professionnelle dans la structuration et l'optimisation de leur situation patrimoniale. Spécialisé dans l'intégration des francophones arrivant en Suisse, il propose un accompagnement sur mesure, de l'installation à l'optimisation complète du patrimoine, avec une approche claire, rigoureuse et orientée résultats.",
      linkedinUrl: "https://www.linkedin.com/in/edouard-barreau/"
    },
    {
      name: "Matthias Gajo",
      title: "Conseiller financier diplômé IAF",
      image: "/assets/team/matthias-gajo.jpeg",
      expertise: ["Diplôme IAF – Institut Assurance et Finance", "Conseil en prévoyance et protection du patrimoine", "Accompagnement des particuliers, PME et indépendants"],
      experience: "+3 ans",
      highlight: "Conseiller financier diplômé IAF, Matthias accompagne ses clients avec rigueur et proximité dans toutes les étapes de leur vie financière. Spécialisé dans la prévoyance et la protection du patrimoine, il allie expertise technique et approche humaine pour proposer des solutions adaptées à chaque situation. Son engagement et son écoute attentive font de lui un partenaire de confiance pour une planification financière sereine et personnalisée.",
      linkedinUrl: "https://www.linkedin.com/in/matthias-gajo-9b523219a/"
    },
    {
      name: "Nathan Wuillemin",
      title: "Conseiller financier certifié IAF",
      image: "/assets/team/nathan-wuillemin.jpeg",
      expertise: ["Certifié IAF – Spécialiste en assurance et prévoyance", "Bachelor en économie d'entreprise", "Accompagnement personnalisé des jeunes actifs et familles"],
      experience: "2+ ans",
      highlight: "Jeune Neuchâtelois sportif et sociable, Nathan a rejoint le monde du conseil financier avec passion et détermination. Certifié IAF – Spécialiste en assurance et prévoyance, il accompagne avec enthousiasme ses clients dans la réalisation de leurs projets. Son approche moderne, son excellent sens relationnel, son adaptabilité et sa grande disponibilité font de lui un conseiller très apprécié.",
      linkedinUrl: "https://www.linkedin.com/in/nathan-wuillemin-05bb54228/"
    },
    {
      name: "Luca Schneider",
      title: "Conseiller financier diplômé IAF",
      image: "/assets/team/luca-schneider.jpeg",
      expertise: ["Planification financière globale", "Conseil patrimonial et prévoyance", "Accompagnement des particuliers et indépendants"],
      experience: "7+ ans",
      highlight: "Fort de plus de 7 ans d'expérience dans le conseil financier, Luca a développé une expertise solide en planification financière et en accompagnement client. Conseiller financier diplômé IAF, il se distingue par sa capacité à analyser les situations complexes et à proposer des solutions claires et efficaces. Son approche méthodique, combinée à un sens aigu du relationnel, lui permet de bâtir des relations de confiance durables avec ses clients.",
      linkedinUrl: "https://www.linkedin.com/in/luca-schneider-/"
    },
    {
      name: "Clovis Burgat",
      title: "Conseiller financier",
      image: "/assets/team/Clovis-Burgat.jpeg",
      expertise: ["Planification financière personnalisée", "Accompagnement des familles et jeunes actifs", "Intégration financière des nouveaux arrivants en Suisse"],
      experience: "3+ ans",
      highlight: "Issu d'un parcours mêlant conseil financier et entrepreneuriat, Clovis développe une approche globale, orientée performance et création de valeur. Il accompagne principalement des familles et des jeunes actifs dans l'organisation et l'optimisation de leur situation financière, en proposant des solutions claires, concrètes et adaptées à chaque étape de vie. Il intervient également auprès de personnes s'installant en Suisse, en leur offrant un accompagnement complet et pédagogique afin de leur transmettre les clés essentielles à une intégration financière sereine. Fort d'une expérience dans la gestion d'activités, il évolue avec aisance dans des environnements exigeants. Son approche humaine, pragmatique et orientée résultats lui permet de bâtir des relations de confiance durables.",
      linkedinUrl: "https://www.linkedin.com/in/clovis-burgat-3618a5253/"
    },
    {
      name: "Thomas Doy",
      title: "Conseiller financier certifié IAF",
      image: "/assets/team/Thomas-doy.png",
      expertise: ["Certification IAF – Assurance et finance", "Protection du patrimoine et prévoyance", "Conseil financier transparent et personnalisé"],
      experience: "4+ ans",
      highlight: "Conseiller financier certifié IAF, Thomas accompagne ses clients avec rigueur et humanité.\n\nSpécialisé dans la protection du patrimoine et la prévoyance, il met son expertise au service de solutions adaptées à chaque situation.\n\nToujours à l'écoute et disponible, son objectif est avant tout de répondre aux besoins de ses clients et de les accompagner de manière active dans la durée.\n\nThomas propose un conseil financier complet, transparent et personnalisé pour chacun de ses clients."
    },
    {
      name: "Matteo Prost",
      title: "Conseiller financier diplômé IAF",
      image: "/assets/team/Matteo_Prost.jpg",
      expertise: ["Planification retraite", "Gestion de fortune", "Stratégies d'investissement"],
      experience: "4+ ans",
      highlight: "Préparer sa retraite, gérer son patrimoine et investir son capital sont des décisions qui méritent une vision claire et une stratégie adaptée. J'accompagne mes clients dans ces étapes clés avec une approche personnalisée, orientée résultats et construite sur des valeurs fortes : loyauté, engagement et confiance.",
      linkedinUrl: "https://www.linkedin.com/in/matteo-prost-b69171223/"
    },
    {
      name: "Marcel Ignacio",
      title: "Conseiller financier",
      image: "/assets/team/Marcel_Ignacio.JPG",
      expertise: ["Conseil multilingue : français, espagnol, catalan et anglais", "Accompagnement personnalisé des particuliers et des familles", "Planification financière et protection du patrimoine"],
      experience: "2+ ans",
      highlight: "Originaire de Neuchâtel et passionné par les relations humaines, Marcel Ignacio accompagne ses clients avec engagement et bienveillance dans la gestion de leurs assurances, de leur prévoyance et de leurs objectifs financiers.\n\nGrâce à son parcours international, sa maîtrise de plusieurs langues et son approche moderne du conseil, il accorde une grande importance à la compréhension des besoins de chacun afin de proposer des solutions adaptées et durables.\n\nReconnu pour son écoute, sa disponibilité et son sens du service, Marcel place la confiance et la proximité au cœur de chaque accompagnement, avec pour objectif d'aider ses clients à construire leur avenir financier en toute sérénité.",
      linkedinUrl: "https://www.linkedin.com/in/marcel-ignacio-6364b3ab/"
    },
    {
      name: "Shabeen Ketheeswaran",
      title: "Conseiller financier",
      image: "/assets/team/Shabeen.png",
      expertise: ["Assurances de personnes et de biens", "Investissements et planification patrimoniale", "Hypothèques et financement immobilier"],
      experience: "2+ ans",
      highlight: "Pour Shabeen, le conseil financier commence par une relation, pas par un produit. Il protège d'abord les familles contre les coups durs, accompagne ses clients dans leurs projets concrets et vise des résultats réels, sans jamais sacrifier la franchise qui le caractérise : il dit les choses telles qu'elles sont.\n\nCe qui le distingue, c'est sa capacité à créer du lien au-delà des barrières. Sa double culture lui a appris à écouter vraiment, à comprendre des réalités différentes et à instaurer la confiance avec chaque client, quel que soit son parcours. Patient, honnête et profondément humain, il bâtit chaque collaboration sur la durée, avec un seul objectif : que ses clients comprennent leurs choix et avancent sereins.",
      linkedinUrl: "https://www.linkedin.com/in/shabeen-ketheeswaran-600b3b231/"
    },
    {
      name: "Rejoignez notre équipe",
      title: "🚀 Nous recrutons !",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face&mask=circle&blur=2",
      expertise: ["Opportunités de croissance", "Formation continue", "Équipe dynamique et bienveillante"],
      experience: "Votre avenir commence ici",
      highlight: "Rejoignez une équipe passionnée où votre talent et votre ambition seront valorisés. Développez votre carrière dans un environnement stimulant avec des perspectives d'évolution exceptionnelles.",
      isOpen: true
    }
  ];

  // Fiches structurées de l'équipe : signal d'expertise et d'autorité (E-E-A-T),
  // déterminant sur les sujets financiers où la qualification de l'auteur compte.
  const BASE_URL = "https://www.atom-group.ch";
  const slugify = (name) => name
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const teamSchema = {
    "@context": "https://schema.org",
    // La dernière entrée de teamMembers est une carte de recrutement, pas une
    // personne : l'exclure, sinon elle est publiée comme un collaborateur.
    "@graph": teamMembers.filter((member) => !member.isOpen).map((member) => ({
      "@type": "Person",
      "@id": `${BASE_URL}/a-propos#${slugify(member.name)}`,
      "name": member.name,
      "jobTitle": member.title,
      "description": member.highlight,
      "image": member.image.startsWith('http') ? member.image : `${BASE_URL}${member.image}`,
      "knowsAbout": member.expertise,
      "worksFor": {
        "@type": "Organization",
        "@id": `${BASE_URL}/#organization`,
        "name": "ATOM Group SA"
      },
      ...(member.linkedinUrl ? { "sameAs": [member.linkedinUrl] } : {})
    }))
  };

  const companyValues = [
    {
      icon: Shield,
      title: "Indépendance",
      description: "Conseil objectif et transparent, sans conflit d'intérêts"
    },
    {
      icon: Target,
      title: "Excellence",
      description: "Expertise reconnue et solutions sur mesure"
    },
    {
      icon: Users,
      title: "Proximité",
      description: "Accompagnement personnalisé et relations durables"
    },
    {
      icon: Award,
      title: "Innovation",
      description: "Solutions modernes et outils digitaux performants"
    }
  ];

  return (
    <div className="pt-20">
      <SEO {...SEOPages.apropos} />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(teamSchema)}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          role="img"
          aria-label="Équipe ATOM Group - conseillers financiers experts à Neuchâtel en Suisse"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1920&h=1080&fit=crop)',
            backgroundBlendMode: 'overlay'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40"></div>
        </div>
        
        <div className="container relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold heading-display text-white mb-6">
              À propos d'<span className="text-blue-300">ATOM Group SA</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Expertise financière indépendante fondée sur plus de 20 ans d'expérience combinée. 
              Notre mission : simplifier vos décisions financières avec des conseils transparents et personnalisés.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="glass p-6 rounded-2xl text-center">
                <div className="text-2xl font-bold text-blue-400 mb-3">Indépendance</div>
                <div className="text-sm text-gray-300 leading-relaxed">Une approche libre et centrée sur vos intérêts.</div>
              </div>
              <div className="glass p-6 rounded-2xl text-center">
                <div className="text-2xl font-bold text-green-400 mb-3">Transparence</div>
                <div className="text-sm text-gray-300 leading-relaxed">Une vision claire, compréhensible et honnête de chaque étape.</div>
              </div>
              <div className="glass p-6 rounded-2xl text-center">
                <div className="text-2xl font-bold text-white mb-3">Proximité</div>
                <div className="text-sm text-gray-300 leading-relaxed">Un accompagnement humain, attentif et durable.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre équipe - Cartes compactes avec modale au clic */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold heading-display text-white mb-6">
              Notre équipe
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Des experts passionnés avec une expertise solide forgée par des années d'expérience dans la finance et l'entrepreneuriat
            </p>
          </div>
          
          {/* Grille des membres - Cartes compactes cliquables */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {teamMembers.filter(member => !member.isOpen).map((member, index) => (
              <div 
                key={index} 
                onClick={() => setSelectedMember(member)}
                className="glass p-6 text-center group hover:scale-105 transition-all duration-300 cursor-pointer hover:bg-white/10"
              >
                {member.isPlaceholder ? (
                  <div className="w-24 h-24 rounded-full mx-auto mb-4 ring-2 ring-white/20 group-hover:ring-blue-400/50 transition-all duration-300 bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center">
                    <Users size={40} className="text-blue-400/70" />
                  </div>
                ) : (
                  <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-4 ring-2 ring-white/20 group-hover:ring-blue-400/50 transition-all duration-300">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                      style={{ objectPosition: 'center 20%', aspectRatio: '1/1' }}
                    />
                  </div>
                )}
                <h3 className="text-lg font-semibold text-white mb-1 group-hover:text-blue-300 transition-colors">{member.name}</h3>
                <p className="text-sm text-blue-300">{member.title}</p>
                <p className="text-xs text-gray-400 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">Cliquez pour en savoir plus</p>
              </div>
            ))}

            {/* Carte "Rejoignez notre équipe" intégrée dans la grille */}
            {teamMembers.filter(member => member.isOpen).map((member, index) => (
              <Link to="/recrutement" key={`open-${index}`} className="block cursor-pointer">
                <div className="glass p-6 text-center group hover:scale-105 transition-all duration-300 border-2 border-blue-400/50 hover:border-blue-400 hover:shadow-2xl hover:shadow-blue-500/20 h-full">
                  <div className="relative w-24 h-24 mx-auto mb-4">
                    {/* Animated gradient background */}
                    <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-400 via-purple-400 to-blue-600 animate-pulse"></div>
                    {/* Icon container */}
                    <div className="relative w-full h-full rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-xl">
                      <UserPlus size={36} className="text-white" strokeWidth={2} />
                    </div>
                    {/* Sparkle effect */}
                    <Sparkles className="absolute -top-1 -right-1 text-yellow-400 animate-pulse" size={18} />
                  </div>
                  
                  <h3 className="text-lg font-semibold text-white mb-1">{member.name}</h3>
                  <p className="text-sm text-blue-300">{member.title}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Modale détails collaborateur */}
      {selectedMember && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={() => setSelectedMember(null)}
        >
          <div 
            className="glass relative w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl p-8 animate-fade-in"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'rgba(30, 41, 59, 0.95)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), inset 0 1px 0 0 rgba(255, 255, 255, 0.1)'
            }}
          >
            {/* Bouton fermer */}
            <button 
              onClick={() => setSelectedMember(null)}
              className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
            >
              <X size={20} className="text-white" />
            </button>

            {/* Contenu de la modale */}
            <div className="flex flex-col md:flex-row gap-6">
              {/* Photo */}
              <div className="flex-shrink-0">
                {selectedMember.isPlaceholder ? (
                  <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl mx-auto md:mx-0 ring-4 ring-blue-400/30 bg-gradient-to-br from-slate-700 to-slate-800 flex items-center justify-center">
                    <Users size={60} className="text-blue-400/70" />
                  </div>
                ) : (
                  <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden mx-auto md:mx-0 ring-4 ring-blue-400/30">
                    <img 
                      src={selectedMember.image}
                      alt={selectedMember.name}
                      className="w-full h-full object-cover"
                      style={{ objectPosition: 'center 20%' }}
                    />
                  </div>
                )}
              </div>

              {/* Infos */}
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-2xl font-bold text-white mb-1">{selectedMember.name}</h3>
                <p className="text-lg text-blue-300 mb-2">{selectedMember.title}</p>
                <div className="inline-block px-3 py-1 bg-blue-500/20 text-blue-300 rounded-full text-sm mb-4">
                  {selectedMember.experience}
                </div>
                
                {/* LinkedIn */}
                {selectedMember.linkedinUrl && (
                  <a
                    href={selectedMember.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 ml-2 px-3 py-1 bg-blue-600/20 hover:bg-blue-600/30 rounded-full transition-colors"
                  >
                    <Linkedin size={14} className="text-blue-400" />
                    <span className="text-sm text-blue-300">LinkedIn</span>
                  </a>
                )}
              </div>
            </div>

            {/* Description */}
            <div className="mt-6">
              <p className="text-gray-300 leading-relaxed">{selectedMember.highlight}</p>
            </div>

            {/* Expertises */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold text-white mb-3">Expertises</h4>
              <div className="space-y-2">
                {selectedMember.expertise.map((skill, i) => (
                  <div key={i} className="flex items-start text-gray-300">
                    <CheckCircle size={16} className="mr-3 mt-0.5 flex-shrink-0 text-green-400" />
                    <span>{skill}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Bouton contact */}
            <div className="mt-8 text-center">
              <Link 
                to="/contact" 
                onClick={() => setSelectedMember(null)}
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-medium rounded-xl transition-all duration-300 hover:scale-105"
              >
                Contacter {selectedMember.name.split(' ')[0]}
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Nos valeurs */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold heading-display text-white mb-6">
              Nos valeurs
            </h2>
            <p className="text-xl text-gray-300">
              Les principes qui guident chaque conseil et décision
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyValues.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div key={index} className="glass p-8 text-center group hover:scale-105 transition-transform">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                    <IconComponent size={32} className="text-white" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-4">{value.title}</h3>
                  <p className="text-gray-300">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Agréments & Conformité Section */}
      <section className="py-20">
        <div className="container">
          <div className="glass p-12 rounded-3xl">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold heading-display text-white mb-6">
                Agréments & Conformité
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                ATOM Group SA est officiellement agréé et respecte les plus hauts standards de l'industrie financière suisse
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              
              {/* LSFIN Conformité */}
              <div className="glass p-8 text-center group hover:bg-green-500/10 transition-all duration-300 flex flex-col">
                <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <CheckCircle size={36} className="text-white" />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">Conforme LSFIN</h3>
                <p className="text-gray-300 mb-8">
                  Respect intégral de la Loi sur les Services Financiers, garantissant transparence et protection des clients
                </p>
                <div className="mt-auto">
                  <span className="inline-block px-4 py-2 bg-green-500/20 text-green-300 rounded-full text-sm font-medium">
                    Standards de protection élevés
                  </span>
                </div>
              </div>

              {/* FINMA */}
              <div className="glass p-8 text-center group hover:bg-blue-500/10 transition-all duration-300 flex flex-col">
                <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <Shield size={36} className="text-white" />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">Enregistré FINMA</h3>
                <p className="text-gray-300 mb-8">
                  Intermédiaire d'assurance non lié enregistré auprès de l'Autorité fédérale de surveillance des marchés financiers
                </p>
                <div className="mt-auto">
                  <span className="inline-block px-4 py-2 bg-blue-500/20 text-blue-300 rounded-full text-sm font-medium">
                    Supervision officielle
                  </span>
                </div>
              </div>
            </div>
            
            {/* Informations complémentaires */}
            <div className="mt-12 text-center">
              <div className="glass p-6 rounded-2xl max-w-3xl mx-auto">
                <p className="text-gray-300 mb-4">
                  <strong className="text-white">Transparence totale :</strong> En tant qu'intermédiaire d'assurance non lié, 
                  nous garantissons des conseils indépendants et objectifs, sans obligation de recommander 
                  les produits d'un assureur spécifique.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm text-blue-300">
                  <div className="flex items-center space-x-2">
                    <span>Conformité LSFIN & FINMA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container">
          <div className="glass p-12 rounded-3xl text-center">
            <h2 className="text-4xl font-bold heading-display text-white mb-6">
              Vous souhaitez nous rejoindre ?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Que vous soyez déjà issu du domaine financier ou que vous souhaitiez vous former au conseil financier, 
              nous serions ravis d'échanger avec vous. N'hésitez pas à nous contacter directement.
            </p>
            <div className="flex justify-center">
              <Link to="/recrutement" className="btn-glass btn-primary text-lg px-12 py-4">
                Rejoindre ATOM Group SA
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default APropos;
